import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ew-price-information',
  templateUrl: './price-information.component.html',
  styleUrls: ['./price-information.component.scss'],
})
export class PriceInformationComponent {
  @Input() price: number = 0;
  @Input() currency: string = '';
  @Input() convertToPrice: number = 0;
  @Input() convertToCurrency: string = '';
  @Input() progress: boolean = false;
  @Input() editable: boolean = true;
  @Input() provider: any;
  @Input() width: string = 'w-2/3 max-w-lg';
  @Input() fontsSizePrice: string = 'xs:text-5xl text-8xl text-center';
  @Output() valueChanged = new EventEmitter<any>();

  constructor() {}

  /**
   * returns the value.
   * @author Martin Batun Tec.
   */
  change(): void {
    const wordSearch = this.price;
    setTimeout(() => {
      if (wordSearch == this.price) {
        this.valueChanged.next(parseFloat(String(this.price || 0)));
      }
    }, 750);
  }
}
